export enum DocumentType {
    DNI = '6312be83-69aa-4b35-a3a5-236479e3f510',
    PASSPORT = '0d5e2fd6-1561-4fc1-8a6e-a9f34d39406d',
    FOREIGN_CARD = 'f5df527c-836e-4abf-8a3a-ec1fe4988738',
    PTP = 'f5df527c-830e-4abf-8a3a-ecafe4988734',
    RUC = 'RUC'
}
